import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";

import Error from "./Error";
import LoadingIcon from "./loading/LoadingIcon";
import { userRoles } from "../api/user-service";
import { UserContext } from "../Contexts";
import { LoadedDataState } from "../scripts/loadedData/loadedData";

/**
 * Render children only for admin users (same checks as AdminDashboard).
 * Children are not mounted otherwise, so their data fetches never fire for non-admins.
 */
const AdminOnly = ({ children }) => {
    const { userData } = useContext( UserContext );

    if (userData.state === LoadedDataState.FAILURE) {
        return <Error message={userData.error?.message} />
    }
    if (userData.state !== LoadedDataState.SUCCESS) {
        return <LoadingIcon />
    }
    if (userData.value?.role !== userRoles.ADMIN) {
        return (
            <Box>
                <Typography variant="h5">You are not authorized to view this page. Go to <a href="/login">homepage</a>.</Typography>
            </Box>
        )
    }
    return children;
};

export default AdminOnly;
